import { render, staticRenderFns } from "./SignatureScreen.view.vue?vue&type=template&id=740f6d18&scoped=true"
import script from "./SignatureScreen.view.vue?vue&type=script&lang=js"
export * from "./SignatureScreen.view.vue?vue&type=script&lang=js"
import style0 from "./SignatureScreen.view.vue?vue&type=style&index=0&id=740f6d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f6d18",
  null
  
)

export default component.exports